module.exports = __webpack_public_path__ + "img/benefit_sleep.0c610af8.png";